var _defs, _rect, _path, _polygon, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin201(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#0077b5;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.17,
    y: 15.17,
    width: 481.65,
    height: 481.65,
    rx: 32.87,
    ry: 32.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m186.31,145.44c-9.14-8-20.44-9.52-31.23-4.44-7.62,3.55-11.04,7.11-14.47,14.72-4.82,10.54-2.92,21.96,5.2,31.1,13.2,14.98,37.83,12.06,46.97-5.59,6.6-12.57,4.06-26.91-6.47-35.8Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "137.95 211.57 137.95 292.81 137.95 374.05 167.14 374.05 196.34 374.05 196.34 292.81 196.34 211.57 167.14 211.57 137.95 211.57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m384.08,251.18c-5.33-17.39-16.38-30.59-30.21-36.05-5.71-2.28-9.52-2.79-19.8-2.67-23.48.13-37.95,6.73-47.22,21.45-1.27,2.03-1.52.13-1.52-10.03l-.13-12.31h-58.39v162.48h58.26l.38-48.62c.38-45.95.51-48.74,3.05-54.2,6.73-14.6,24.75-20.18,33.77-10.41,6.85,7.24,6.73,6.22,7.11,61.44l.38,51.79h59.53v-44.3c0-47.73-1.14-65.25-5.2-78.57Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin201);
export default __webpack_public_path__ + "static/media/linkedin_2_-01.27bbb4a9b6268f23d55f29d2f0f05088.svg";
export { ForwardRef as ReactComponent };